// First-party conversion tracking — no third party, consent-gated.
// Only sends events when the visitor granted optional-cookie consent
// (localStorage key `vtc_consent_v1` → optionalCookies === true).
import axios from "axios";
import { API } from "@/lib/api";

const CONSENT_KEY = "vtc_consent_v1";
const SESSION_KEY = "vtc_session_id";

function hasConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return parsed?.version === 1 && parsed?.optionalCookies === true;
  } catch {
    return false;
  }
}

function sessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
}

export function track(event, meta = null) {
  if (!hasConsent()) return;
  try {
    axios.post(`${API}/track`, { event, session_id: sessionId(), meta }).catch(() => {});
  } catch {
    /* silent */
  }
}

export default track;
